import { lazy } from "react";
import { URL } from "./constants";
import Home from "../components/Home";
import Channel from "../components/inbox/hub/channel";
import ChannelFacebook from "../components/inbox/hub/channel-facebook";
import Keyword from "../components/posts_comments/autocomment/keyword";
import CampaignList from "../components/posts_comments/sale_post/campaign-list";
import DefaultSettings from "../components/posts_comments/sale_post/DefaultSettings/index";
import PostEdit from "../components/posts_comments/posts-list/post-edit";
import PostsList from "../components/posts_comments/posts-list/posts-list";
import SetupKeyword from "../components/chat_assistant/setup/keyword";
import SetupRef from "../components/chat_assistant/setup/ref";
import SetupTrigger from "../components/chat_assistant/setup/trigger";
import SetupSequence from "../components/chat_assistant/setup/sequence";
import ContentFlow from "../components/chat_assistant/content/flow";
import CampaignEdit from "../components/posts_comments/sale_post/campaign-list/edit";
import Cart from "../components/cart";
import Detail from "../components/cart/detail";
import Payment from "../components/cart/payment";
import ThankYou from "../components/cart/payment/thank-you";
import PaymentResult from "../components/cart/payment/payment-result";
import Login from "../components/Login";
import Service from "../components/Pages/Service";
import Policy from "../components/Pages/Policy";
import Page404 from "../components/Pages/404";
import General from "../components/chat_assistant/messenger_settings/general";
import Faq from "../components/chat_assistant/messenger_settings/faq/home";
import FaqEdit from "../components/chat_assistant/messenger_settings/faq/edit";
import Instagram from "../components/chat_assistant/messenger_settings/instagram";
import Comment from "../components/chat_assistant/conversation/comment";
import GeneralConversation from "../components/chat_assistant/conversation/general";
import TagList from "../components/chat_assistant/conversation/taglist";
import TagExtension from "../components/chat_assistant/conversation/tagextension";
import TagFolder from "../components/chat_assistant/conversation/tagfolder";
import ChatHint from "../components/chat_assistant/chat_hint";
import LiveCampaignList from "../components/Livestream/LiveCampaignList/Home";
import ConnectionStatus from "../components/chat_assistant/connection_status";
import Customer from "../components/customer/index";
import VideoLive from "../components/Livestream/VideoLive";
const Video = lazy(() => import("../components/Upload/Video"));
const InboxConversation = lazy(() => import("../components/inbox/Conversation"));
const WelcomeMessage = lazy(() => import("../components/chat_assistant/messenger_settings/welcome-message"));
const Intro = lazy(() => import("../components/intro"));
const LiveDefaultSettings = lazy(() => import("../components/Livestream/LiveCampaignList/DefaultSettings"));
const LiveEditCampaign = lazy(() => import("../components/Livestream/LiveCampaignList/Edit"));
const TaskManagement = lazy(() => import("../components/TaskManagement"));
const LiveStreamSupport = lazy(() => import("../components/Support/LiveStream"));

export const routes = [
   {
      path: URL.HOME,
      element: <Home />
   },
   {
      path: URL.CHANNEL,
      element: <Channel />
   },
   {
      path: URL.CHANNEL_FACEBOOK,
      element: <ChannelFacebook />
   },
   {
      path: URL.POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_LIST,
      element: <CampaignList />
   },
   {
      path: URL.POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_EDIT,
      element: <CampaignEdit />
   },
   {
      path: URL.POSTS_COMMENTS_SALE_POSTS_SETTING,
      element: <DefaultSettings />
   },
   {
      path: URL.POSTS_COMMENTS_SALE_POSTS_SETTING_CAMPAIGN,
      element: <DefaultSettings />
   },
   {
      path: URL.POSTS_COMMENTS_POSTS_POSTS_LIST,
      element: <PostsList />
   },
   {
      path: URL.POSTS_COMMENTS_POSTS_POSTS_LIST_EDIT,
      element: <PostEdit />
   },
   {
      path: URL.POSTS_COMMENTS_AUTOCOMMENT_KEYWORD,
      element: <Keyword />
   },
   {
      path: URL.SHOPPING_CART,
      element: <Cart />
   },
   {
      path: URL.DETAIL_CART,
      element: <Detail />
   },
   {
      path: URL.SHOPPING_CART_PAYMENT,
      element: <Payment />
   },
   {
      path: URL.SHOPPING_CART_THANK_YOU,
      element: <ThankYou />
   },
   {
      path: URL.SHOPPING_CART_PAY_RESULT,
      element: <PaymentResult />
   },
   {
      path: URL.LOGIN,
      element: <Login />
   },
   {
      path: URL.PAGE_POLICY,
      element: <Policy />
   },
   {
      path: URL.PAGE_QD,
      element: <Service />
   },
   {
      path: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_GENERAL,
      element: <General />
   },
   {
      path: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_FAQ,
      element: <Faq />
   },
   {
      path: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_FAQ_FLOW_EDIT,
      element: <FaqEdit />
   },
   {
      path: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_MAINMENU,
      element: <Service />
   },
   {
      path: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_DEFAULTREPLY,
      element: <Service />
   },
   {
      path: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_WELCOMEMESSAGE,
      element: <WelcomeMessage />
   },
   {
      path: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_INSTAGRAM,
      element: <Instagram />
   },
   {
      path: URL.CHAT_ASSISTANT_CONVERSATION_GENERAL,
      element: <GeneralConversation />
   },
   {
      path: URL.CHAT_ASSISTANT_CONVERSATION_COMMENT,
      element: <Comment />
   },
   {
      path: URL.CHAT_ASSISTANT_CONVERSATION_TAGLIST,
      element: <TagList />
   },
   {
      path: URL.CHAT_ASSISTANT_CONVERSATION_TAGFOLDER,
      element: <TagFolder />
   },
   {
      path: URL.CHAT_ASSISTANT_CONVERSATION_TAGEXTENSION,
      element: <TagExtension />
   },
   {
      path: URL.CHAT_ASSISTANT_SETUP_KEYWORD,
      element: <SetupKeyword />
   },
   {
      path: URL.CHAT_ASSISTANT_SETUP_REF,
      element: <SetupRef />
   },
   {
      path: URL.CHAT_ASSISTANT_SETUP_SEQUENCE,
      element: <SetupSequence />
   },
   {
      path: URL.CHAT_ASSISTANT_SETUP_TRIGGER,
      element: <SetupTrigger />
   },
   {
      path: URL.CHAT_ASSISTANT_CONTENT_FLOW,
      element: <ContentFlow />
   },
   {
      path: URL.CHAT_ASSISTANT_CHAT_HINT,
      element: <ChatHint />
   },
   {
      path: URL.CHAT_ASSISTANT_CONNECTION_STATUS,
      element: <ConnectionStatus />
   },
   {
      path: URL.LIVESTREAM_LIVE_CAMPAIGN_LIST,
      element: <LiveCampaignList />
   },
   {
      path: URL.LIVESTREAM_LIVE_CAMPAIGN_LIST_DEFAULT_SETTINGS,
      element: <LiveDefaultSettings />
   },
   {
      path: URL.LIVESTREAM_LIVE_CAMPAIGN_LIST_SETTING_CAMPAIGN,
      element: <LiveDefaultSettings />
   },
   {
      path: URL.LIVESTREAM_LIVE_CAMPAIGN_LIST_EDIT,
      element: <LiveEditCampaign />
   },
   {
      path: URL.TASK_MANAGEMENT,
      element: <TaskManagement />
   },
   {
      path: URL.INTRO,
      element: <Intro />
   },
   {
      path: URL.INBOX,
      element: <InboxConversation />
   },
   {
      path: URL.CUSTOMER_ALL,
      element: <Customer />
   },
   {
      path: URL.UPLOAD_VIDEO,
      element: <Video />
   },
   {
      path: URL.LIVE_VIDEO_ON_PAGE,
      element: <VideoLive/>
   },
   {
      path: URL.SUPPORT_LIVESTREAM,
      element: <LiveStreamSupport/>
   },
   {
      path: "*",
      element: <Page404 />
   }
]